import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICorretor } from '../types/ICorretor';

@Injectable({ providedIn: 'root' })
export class CorretorState {
  private corretor = new BehaviorSubject<ICorretor | null>(null);
  private requestingCorretor = new BehaviorSubject<boolean>(false);
  private requestingLogin = new BehaviorSubject<boolean>(false);

  public setCorretor(corretor: ICorretor) {
    this.corretor.next(corretor);
  }

  public getCorretor() {
    return this.corretor.asObservable();
  }

  public getCorretorValue() {
    return this.corretor.getValue();
  }

  public setRequestingCorretor(isLoading: boolean) {
    this.requestingCorretor.next(isLoading);
  }

  public isRequestingCorretor() {
    return this.requestingCorretor.asObservable();
  }

  public setRequestingLogin(isLoading: boolean) {
    this.requestingLogin.next(isLoading);
  }

  public isRequestingLogin() {
    return this.requestingLogin.asObservable();
  }

  public isEmpty() {
    return this.corretor.getValue() === null;
  }

  public reset() {
    this.corretor.next(null);
    this.requestingCorretor.next(false);
    this.requestingLogin.next(false);
  }
}